import React from 'react';
import { useParams, Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import ProjectDetailsSec from '../components/sections/ProjectDetailsSec';
import ProjectSecOne from '../components/sections/ProjectSecOne';
import projects from '../components/data/projects';

const PortfolioDetails = () => {
  const { t } = useTranslation();
  const { slug } = useParams();

  // Find the project by slug
  const project = projects.find(p => p.slug === slug);

  // If no slug is provided (accessing /portfolio-details directly), use the first project
  const currentProject = slug ? project : projects[0];
  // If slug is provided but project not found, redirect to portfolio page
  if (slug && !project) {
    return <Navigate to="/portfolio" replace />;
  }
  
  // Get project title from translation
  const projectTitle = currentProject ? t(currentProject.titleKey) : t('sections.breadcrumb.portfolio_details.title');
  
  return (
    <>
      <Header />
        <Breadcrumb 
          title={projectTitle}
          subtitle={projectTitle}
        />
        <ProjectDetailsSec className="space-top space-extra-bottom overflow-hidden" />
        <ProjectSecOne className="space-bottom overflow-hidden" />
      <Footer />
    </>
  );
};

export default PortfolioDetails;